"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.dropShadowValues = void 0;
const Utils_1 = require("../../utils/Utils");
exports.dropShadowValues = {
    $dropShadow100: (0, Utils_1.constructShadowStyles)({}),
    $dropShadow200: (0, Utils_1.constructShadowStyles)({ blur: '4px', color: 'rgba(0, 0, 0, 0.25)' }),
    $dropShadow300: (0, Utils_1.constructShadowStyles)({ color: 'rgba(11, 16, 14, 0.8)' }),
};
